import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppSettingsService } from './app-settings.service';

export interface IGroupModel {
  /** The unique numeric identifier of the group */
  groupId: number;
  /** The name of the group */
  groupName: string;
  /** The short name/prefix of the group */
  shortGroupName: string;
  /** Indicator of whether the group has been disabled within the system */
  isDisabled: boolean;
  /** Indicator of whether the group has been deleted within the system */
  isDeleted: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class GroupService {
  /**
   * Inject HttpClient directly here instead of HttpService to prevent circular dependency
   * (and since GroupService does not require custom HttpService behavior).
   */
  constructor(private http: HttpClient, private appSettings: AppSettingsService) {}

  /** Retrieves the list of all groups */
  public getGroups = (): Observable<IGroupModel[]> => {
    return this.http.get<IGroupModel[]>(this.appSettings.groupServiceUrl);
  };

  /** Retrieves the list of all groups */
  public getGroup = (groupId): Observable<IGroupModel> => {
    return this.http.get<IGroupModel>(this.appSettings.groupServiceUrl + groupId);
  };

  /** Add a group */
  public createGroup = (value: IGroupModel): Observable<IGroupModel> => {
    return this.http.post<IGroupModel>(this.appSettings.groupServiceUrl, value);
  };

  /** Update a group */
  public updateGroup = (value: IGroupModel): Observable<IGroupModel> => {
    return this.http.put<IGroupModel>(this.appSettings.groupServiceUrl + value.groupId, value);
  };

  /** Update a group */
  public deleteGroup = (value: IGroupModel): Observable<IGroupModel> => {
    return this.http.delete<IGroupModel>(this.appSettings.groupServiceUrl + value.groupId);
  };
}
